// All available subscription plans with complete details
export const ALL_PLANS = [
  {
    id: 'iit-jee',
    name: 'IIT-JEE Success Plan',
    icon: '🚀',
    price: 1200,
    duration: '4 Months',
    color: 'from-indigo-500 to-purple-600',
    features: [
      '1500 Top MCQs',
      'AI Buddy for Doubt solving – 1500 Free Nerd AI Credits (30 Days - Validity)',
      'Solutions with Detailed Explanations',
      'Practice anytime, anywhere'
    ]
  },
  {
    id: 'neet-ug',
    name: 'UG-NEET Success Plan',
    icon: '🩺',
    price: 1200,
    duration: '4 Months',
    color: 'from-green-500 to-teal-600',
    features: [
      '1500 Top MCQs',
      'AI Buddy for Doubt solving – 1500 Free Nerd AI Credits (30 Days - Validity)',
      'Solutions with Detailed Explanations',
      'Practice anytime, anywhere'
    ]
  },
  {
    id: 'gre',
    name: 'GRE Success Plan',
    icon: '🌍',
    price: 1200,
    duration: '4 Months',
    color: 'from-green-500 to-emerald-600',
    features: [
      '1000+ Top MCQs',
      'AI Buddy for Doubt solving – 1500 Free Nerd AI Credits (30 Days - Validity)',
      'Solutions with Detailed Explanations',
      'Practice anytime, anywhere'
    ]
  },
  {
    id: 'gmat',
    name: 'GMAT Success Plan',
    icon: '📊',
    price: 1200,
    duration: '4 Months',
    color: 'from-purple-500 to-indigo-600',
    features: [
      '1000+ Top MCQs',
      'AI Buddy for Doubt solving – 1500 Free Nerd AI Credits (30 Days - Validity)',
      'Solutions with Detailed Explanations',
      'Practice anytime, anywhere'
    ]
  },
  {
    id: 'medical-global',
    name: 'Medical Nerds Global Success',
    icon: '🌏',
    price: 3000,
    duration: '6 Months',
    color: 'from-blue-700 to-blue-800',
    popular: true,
    features: [
      'DHA MCQ',
      'USMLE STEP 1',
      'USMLE STEP 2CK',
      'USMLE STEP 3',
      'AMC MCQ',
      'MCCQE PART 1',
      'PLAB 1',
      'AI Buddy for Doubt solving - 1500 Free Nerd AI Credits (90 Days - Validity)'
    ]
  },
  {
    id: 'dentist-global',
    name: 'Dentist Global Success',
    icon: '🦷',
    price: 3000,
    duration: '6 Months',
    color: 'from-cyan-500 to-blue-600',
    popular: true,
    features: [
      'DHA DENTAL',
      'ADC PART 1',
      'ORE Part 1',
      'INBDE',
      'AI Buddy for Doubt solving - 1500 Free Nerd AI Credits (90 Days - Validity)'
    ]
  },
  {
    id: 'pharmacist-global',
    name: 'Pharmacist Global Success Plan',
    icon: '💊',
    price: 3000,
    duration: '6 Months',
    color: 'from-teal-500 to-green-600',
    popular: true,
    features: [
      'NAPLEX MCQs',
      'MPJE MCQs',
      'PEBC Part 1',
      'GPhC Paper 1 Calculations',
      'GPhC Paper 2 Clinical',
      'Australia OPRA',
      'New Zealand CAP',
      'DHA Pharmacy MCQs',
      'SPLE MCQs',
      'AI Buddy for Doubt solving - 1500 Free Nerd AI Credits (90 Days - Validity)'
    ]
  },
  {
    id: 'research-scholars',
    name: 'Research Scholars',
    icon: '🔬',
    price: 10000,
    duration: '90 Days',
    color: 'from-purple-500 to-pink-600',
    popular: true,
    features: [
      'AI Buddy for Doubt solving - 1500 Free Nerd AI Credits (90 Days - Validity)',
      'Learn Research with Nerd-AI',
      '20 Research paper analysis',
      'Create a Research Proposal Template !'
    ]
  },
  {
    id: 'engineering-student-success',
    name: 'Engineering Student Success Plan',
    subtitle: '(For JNTU Students & Graduates)',
    icon: '⚙️',
    price: 3000,
    duration: '12 Months',
    color: 'from-blue-500 to-cyan-600',
    jntuSpecial: true,
    features: [
      'GRE',
      'GMAT',
      'Learn Research with Nerd-AI',
      'Create a Research Proposal Template !',
      'AI Buddy for Doubt solving - 1500 Free Nerd AI Credits (90 Days - Validity)',
      '⭐ Unlimited Access to All Top Courses Listed below for 1 year'
    ]
  },
  {
    id: 'business-finance-student-success',
    name: 'Business & Finance Student Success Plan',
    subtitle: '(For JNTU Students & Graduates)',
    icon: '💼',
    price: 3000,
    duration: '12 Months',
    color: 'from-amber-500 to-orange-600',
    jntuSpecial: true,
    features: [
      'GRE',
      'GMAT',
      'Learn Research with Nerd-AI',
      'Create a Research Proposal Template !',
      'AI Buddy for Doubt solving - 1500 Free Nerd AI Credits (90 Days - Validity)',
      '⭐ Unlimited Access to All Top Courses Listed below for 1 year'
    ]
  },
  {
    id: 'pharma-student-success',
    name: 'Pharma Student Success Plan',
    subtitle: '(For JNTU Students & Graduates)',
    icon: '⚕️',
    price: 3000,
    duration: '12 Months',
    color: 'from-teal-500 to-green-600',
    jntuSpecial: true,
    features: [
      'GRE',
      'GMAT',
      '⭐ International Pharmacist Success Bank',
      'Learn Research with Nerd-AI',
      'Create a Research Proposal Template !',
      'AI Buddy for Doubt solving - 1500 Free Nerd AI Credits (90 Days - Validity)',
      '⭐ Unlimited Access to All Top Courses Listed below for 1 year'
    ]
  },
  {
    id: 'lifesciences-student-success',
    name: 'Life-Sciences Student Success Plan',
    subtitle: '(For JNTU Students & Graduates)',
    icon: '🧬',
    price: 3000,
    duration: '12 Months',
    color: 'from-emerald-500 to-lime-600',
    jntuSpecial: true,
    features: [
      'GRE',
      'GMAT',
      'Learn Research with Nerd-AI',
      'Create a Research Proposal Template !',
      'AI Buddy for Doubt solving - 1500 Free Nerd AI Credits (90 Days - Validity)',
      '⭐ Unlimited Access to All Top Courses Listed below for 1 year'
    ]
  }
];

// Helper to get plan by ID
export const getPlanById = (planId) => {
  return ALL_PLANS.find(plan => plan.id === planId);
};
